function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "X_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.64 139.64h744.73v760.78H139.64z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#X_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m582.85 461.61 277.24-321.97h-65.7L553.66 419.2 361.4 139.64H139.64l290.75 422.75-290.75 337.63h65.7l254.22-295.23 203.05 295.23h221.76L582.84 461.6h.01Zm-89.99 104.5-29.46-42.1-234.39-334.96h100.91l189.16 270.33 29.46 42.1 245.89 351.38H693.52L492.87 566.13v-.02Z",
    style: {
      fill: "#231309"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.51 462.41 308.98 449.25h-250L458.53 623.83 210.68 911.66h-96.42l301.45-350.07L117.51 128h250.01L554.7 400.17 789.06 128h96.41L597.51 462.42Zm-20-12.44 257.21-298.7h-34.99l-247.1 286.96-197.35-286.96H161.76l283.29 411.91-280.04 325.21H200l260.58-302.62 208.14 302.62h193.52L560.71 449.97h16.81Zm-96.29 119.81-27.35-39.09-247.2-353.28h129.32L528.62 452.7l29.46 42.1 258.7 369.69H687.46l-206.23-294.7v-.02Zm23.27-7.32v-.02l-31.56-45.1-221.57-316.65h72.51l185.69 265.36 29.46 42.1 233.07 333.08h-72.51L504.51 562.47Z",
    style: {
      fill: "#231309",
      fillRule: "evenodd"
    }
  })));
};
export default SvgX;